<template>
  <div>
    <span>
      <b-button
        v-if="faturaSilValidate == true"
        variant="outline-light"
        v-on:click="sepetSil()"
        ><Icon
          icon="material-symbols:delete-forever"
          width="25"
          height="25"
          v-b-tooltip.hover.bottom="'SİL'"
          color="#EA5455"
      /></b-button>

      <b-button v-else variant="outline-light"
        ><Icon
          icon="material-symbols:delete-forever"
          width="25"
          height="25"
          v-b-tooltip.hover.bottom="'SİL'"
      /></b-button>
    </span>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import { Icon } from "@iconify/vue2";
export default {
  components: { Icon },
  computed: {
    faturaSilValidate() { 
      return Store.state.account.faturaSilButonValidate;
    }
  },

  methods: {
    sepetSil() {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;

      var args = {
        token: Store.state.tokenId,
        ID: this.params.data.ID
      };
      soap.createClient(url, function(err, client) {
        client.INT_IadeArizaliUrunSepetSil(args, function(err, result) {
          if (result.INT_IadeArizaliUrunSepetSilResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vm.veriler = JSON.parse(result.INT_IadeArizaliUrunSepetSilResult);
            vs.notify({
              title: "Sepet",
              text: "Ürün silindi.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center"
            });
            vm.$root.$emit("iadearizasepetList");
          } catch (error) {
            vs.notify({
              title: "Sepet",
              text: "Ürün silinirken hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    }
  }
};
</script>
